<template>
	<v-layout row wrap style="page-break-inside: avoid">
		<v-flex d-flex xs12>
			<v-card color="grey darken-3" class="financial-table-header-font-size">
				<v-card-text class="financial-table-header-dark-color">
					<h3>
						{{text}}
					</h3>
				</v-card-text>
			</v-card>
		</v-flex>
	</v-layout>
</template>
<script>
	export default {
		name: 'final-report-header-row',
		props: {
			text: {},
			color: {}
		}
	};
</script>